module.exports = __webpack_public_path__ + "img/select-arrow.92a113d3.svg";